"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonModule = _interopRequireDefault(require("./button.module.scss"));

var _excluded = ["className", "children", "primary", "raised", "flat", "hideLabel", "warning", "icon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var _cx;

  var className = _ref.className,
      children = _ref.children,
      primary = _ref.primary,
      raised = _ref.raised,
      flat = _ref.flat,
      hideLabel = _ref.hideLabel,
      warning = _ref.warning,
      icon = _ref.icon,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: (0, _classnames["default"])(_buttonModule["default"].button, className, (_cx = {}, _defineProperty(_cx, _buttonModule["default"].primary, primary), _defineProperty(_cx, _buttonModule["default"].raised, raised), _defineProperty(_cx, _buttonModule["default"].warning, warning), _defineProperty(_cx, _buttonModule["default"].icon, icon), _cx))
  }, others), icon, children);
};

Button.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  primary: _propTypes["default"].bool,
  raised: _propTypes["default"].bool,
  flat: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  warning: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool
};
Button.defaultProps = {
  className: '',
  disabled: false,
  children: null,
  primary: false,
  raised: false,
  flat: false,
  type: 'button',
  warning: false,
  icon: null,
  hideLabel: false
};
var _default = Button;
exports["default"] = _default;